import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ContentPopup from "../organisms/OrganismsContentPopup";

const MorningDuration = 20;

const MealDuration = 60;

const ClubDuration = 180;

const ClassEduDuration = 55;

const ClassEduDuration2 = 45;

const AfterSchoolDuration = 10;

let TimeTable = [
  {
    index: 0,
    start_time: "00:00",
    duration: MorningDuration,
    title: "아침조례",
    content: "아침조례",
  },
  {
    index: 1,
    start_time: "00:00",
    duration: MealDuration,
    title: "점심시간",
    content: "점심 내용",
  },
  {
    index: 2,
    start_time: "00:00",
    duration: AfterSchoolDuration,
    title: "종례 시간",
    content: "종례 시간",
  },
  {
    index: 3,
    start_time: "00:00",
    duration: ClubDuration,
    title: "동아리활동",
    content: "동아리 활동 내용",
  },
  {
    index: 4,
    start_time: "00:00",
    duration: ClassEduDuration,
    title: "1교시",
    content: "저녁 내용",
  },
  {
    index: 5,
    start_time: "00:00",
    duration: ClassEduDuration,
    title: "2교시",
    content: "2교시 내용",
  },
  {
    index: 6,
    start_time: "00:00",
    duration: ClassEduDuration,
    title: "3교시",
    content: "3교시 내용",
  },
  {
    index: 7,
    start_time: "00:00",
    duration: ClassEduDuration2,
    title: "4교시",
    content: "4교시 내용",
  },
  {
    index: 8,
    start_time: "00:00",
    duration: ClassEduDuration,
    title: "5교시",
    content: "5교시 내용",
  },
  {
    index: 9,
    start_time: "00:00",
    duration: ClassEduDuration,
    title: "6교시",
    content: "6교시 내용",
  },
  {
    index: 10,
    start_time: "00:00",
    duration: ClassEduDuration,
    title: "7교시",
    content: "7교시 내용",
  },
];

// TimeSlot 컴포넌트들
const TimeSlotContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: ${(props) => props.height || 160}px;
  padding: 4px;
  border-bottom: 1px #d1d1d6 solid;
  opacity: ${(props) => (props.isPast ? 0.5 : 1)};
  justify-content: center;
`;

const TimeSlotContent = styled.div`
  flex: 1;
  padding: 12px;
  background: ${(props) => props.background || "#F9F9FB"};
  border-radius: 5px;
  border: ${(props) => props.border || "none"};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;

  &:hover {
    background: ${(props) =>
      props.background ? props.background + "CC" : "#F0F0F0"};
  }
`;

const TimeSlotTitle = styled.span`
  color: ${(props) => (props.isPast ? "rgba(50, 50, 50, 0.5)" : "#323232")};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 24px;
  display: block;
`;

const TimeSlotTime = styled.span`
  color: ${(props) => (props.isPast ? "rgba(50, 50, 50, 0.5)" : "#323232")};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 24px;
`;

const AddContentButton = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 20px;
  cursor: ${(props) => (props.isPast ? "not-allowed" : "pointer")};
  transition: background-color 0.2s ease;
  position: relative;

  &:hover {
    background: ${(props) => (props.isPast ? undefined : "#FAFAFC")};
  }

  &:hover .icon {
    transform: ${(props) => (props.isPast ? "none" : "translateX(-70px)")};
  }

  .icon {
    width: 32px;
    height: 32px;
    background: none;
    border-radius: 9.85px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #8e8e93;
    font-weight: 300;
    transition: ${(props) => (props.isPast ? "none" : "transform 0.2s ease")};
  }

  .text {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -45%) translateX(8px);
    color: #8e8e93;
    font-size: 20px;
    font-family: Pretendard;
    font-weight: 500;
    line-height: 24px;
    opacity: 0;
    transition: ${(props) => (props.isPast ? "none" : "opacity 0.2s ease")};
    white-space: nowrap;
  }

  &:hover .text {
    opacity: ${(props) => (props.isPast ? 0 : 1)};
  }
`;

// 메인 컴포넌트들
const MoleculeContentTimeline = ({
  viewType = "weekly",
  onViewTypeChange = () => {},
  weekOffset = 0,
  onWeekOffsetChange = () => {},
  contentList = [],
  eduTimetableDetail = null,
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [selectedViewType, setSelectedViewType] = useState(viewType);

  // 더미 데이터 사용 여부 설정 (실제 운영시에는 false로 설정)
  // true: 1-7교시에 다양한 콘텐츠 표시 (테스트용)
  // false: 1-7교시 모두 '콘텐츠 등록' 버튼만 표시 (실제 운영)
  const USE_DUMMY_DATA = false;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // 1분마다 업데이트

    return () => clearInterval(timer);
  }, []);

  // viewType prop이 변경되면 selectedViewType 업데이트
  useEffect(() => {
    setSelectedViewType(viewType);
  }, [viewType]);

  const getWeekDates = () => {
    const today = new Date();
    const monday = new Date(today);
    const day = monday.getDay();
    const diff = monday.getDate() - day + (day === 0 ? -6 : 1);
    monday.setDate(diff);

    // weekOffset을 적용하여 주를 이동
    monday.setDate(monday.getDate() + weekOffset * 7);

    const weekDates = [];
    for (let i = 0; i < 5; i++) {
      const date = new Date(monday);
      date.setDate(monday.getDate() + i);
      weekDates.push(date);
    }
    return weekDates;
  };

  const getCurrentTimePosition = () => {
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // 실제 시간표 정의 (분 단위)
    const schedule = [
      { name: "아침조례", start: 8 * 60 + 30, duration: 20 }, // 8:30-8:50
      { name: "1교시", start: 8 * 60 + 50, duration: 55 }, // 8:50-9:45
      { name: "2교시", start: 9 * 60 + 45, duration: 55 }, // 9:45-10:40
      { name: "3교시", start: 10 * 60 + 40, duration: 55 }, // 10:40-11:35
      { name: "4교시", start: 11 * 60 + 35, duration: 45 }, // 11:35-12:20
      { name: "점심시간", start: 12 * 60 + 20, duration: 60 }, // 12:20-13:20
      { name: "5교시", start: 13 * 60 + 20, duration: 55 }, // 13:20-14:15
      { name: "6교시", start: 14 * 60 + 15, duration: 55 }, // 14:15-15:10
      { name: "7교시", start: 15 * 60 + 10, duration: 55 }, // 15:10-16:05
      { name: "종례시간", start: 16 * 60 + 5, duration: 10 }, // 16:05-16:15
      { name: "방과후", start: 16 * 60 + 15, duration: 180 }, // 16:15-19:15
    ];

    let accumulatedHeight = 50; // 헤더 높이

    for (let i = 0; i < schedule.length; i++) {
      const period = schedule[i];
      const periodEnd = period.start + period.duration;

      if (currentMinutes >= period.start && currentMinutes <= periodEnd) {
        // 현재 시간이 이 시간대에 속함
        const progressInPeriod = currentMinutes - period.start;
        const periodHeight = getTimeSlotHeight(period.name);
        const positionInPeriod =
          (progressInPeriod / period.duration) * periodHeight;
        return accumulatedHeight + positionInPeriod;
      }

      if (currentMinutes < period.start) {
        // 현재 시간이 이 시간대보다 이전
        return accumulatedHeight;
      }

      // 다음 시간대로 이동
      accumulatedHeight += getTimeSlotHeight(period.name);
    }

    // 방과후 시간 이후
    return accumulatedHeight;
  };

  const getTimeSlotHeight = (periodName) => {
    switch (periodName) {
      case "아침조례":
      case "종례시간":
        return 72;
      case "점심시간":
        return 160;
      case "1교시":
      case "2교시":
      case "3교시":
      case "4교시":
      case "5교시":
      case "6교시":
      case "7교시":
        return 160; // 기본 1교시 높이
      case "방과후":
        return 480;
      default:
        return 160;
    }
  };

  const isCurrentDay = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const isPastDay = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);
    return compareDate < today;
  };

  const isPastTime = (timeSlot, date) => {
    const now = new Date();
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);

    // 다른 날짜는 isPastDay에서 처리
    if (compareDate.getTime() !== today.getTime()) {
      return false;
    }

    // 당일인 경우만 시간 비교
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // 실제 시간표 정의 (분 단위)
    const schedule = {
      morning: { start: 8 * 60 + 30, end: 8 * 60 + 50 }, // 8:30-8:50
      class: {
        1: { start: 8 * 60 + 50, end: 9 * 60 + 45 }, // 8:50-9:45
        2: { start: 9 * 60 + 45, end: 10 * 60 + 40 }, // 9:45-10:40
        3: { start: 10 * 60 + 40, end: 11 * 60 + 35 }, // 10:40-11:35
        4: { start: 11 * 60 + 35, end: 12 * 60 + 20 }, // 11:35-12:20
        5: { start: 13 * 60 + 20, end: 14 * 60 + 15 }, // 13:20-14:15
        6: { start: 14 * 60 + 15, end: 15 * 60 + 10 }, // 14:15-15:10
        7: { start: 15 * 60 + 10, end: 16 * 60 + 5 }, // 15:10-16:05
      },
      lunch: { start: 12 * 60 + 20, end: 13 * 60 + 20 }, // 12:20-13:20
      closing: { start: 16 * 60 + 5, end: 16 * 60 + 15 }, // 16:05-16:15
      afterschool: { start: 16 * 60 + 15, end: 19 * 60 + 15 }, // 16:15-19:15
    };

    if (timeSlot.type === "morning") {
      return currentMinutes > schedule.morning.end;
    } else if (timeSlot.type === "class") {
      const period = schedule.class[timeSlot.period];
      return period && currentMinutes > period.end;
    } else if (timeSlot.type === "lunch") {
      return currentMinutes > schedule.lunch.end;
    } else if (timeSlot.type === "closing") {
      return currentMinutes > schedule.closing.end;
    } else if (timeSlot.type === "afterschool") {
      return currentMinutes > schedule.afterschool.end;
    }

    return false;
  };

  const isCurrentTimeSlot = (timeSlot, date) => {
    const now = new Date();
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);

    // 오늘이 아닌 경우는 활성화하지 않음
    if (compareDate.getTime() !== today.getTime()) {
      return false;
    }

    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // 실제 시간표 정의
    const schedule = {
      morning: { start: 8 * 60 + 30, end: 8 * 60 + 50 }, // 8:30-8:50
      class: {
        1: { start: 8 * 60 + 50, end: 9 * 60 + 45 }, // 8:50-9:45
        2: { start: 9 * 60 + 45, end: 10 * 60 + 40 }, // 9:45-10:40
        3: { start: 10 * 60 + 40, end: 11 * 60 + 35 }, // 10:40-11:35
        4: { start: 11 * 60 + 35, end: 12 * 60 + 20 }, // 11:35-12:20
        5: { start: 13 * 60 + 20, end: 14 * 60 + 15 }, // 13:20-14:15
        6: { start: 14 * 60 + 15, end: 15 * 60 + 10 }, // 14:15-15:10
        7: { start: 15 * 60 + 10, end: 16 * 60 + 5 }, // 15:10-16:05
      },
      lunch: { start: 12 * 60 + 20, end: 13 * 60 + 20 }, // 12:20-13:20
      closing: { start: 16 * 60 + 5, end: 16 * 60 + 15 }, // 16:05-16:15
    };

    if (timeSlot.type === "morning") {
      return (
        currentMinutes >= schedule.morning.start &&
        currentMinutes <= schedule.morning.end
      );
    } else if (timeSlot.type === "class") {
      const period = schedule.class[timeSlot.period];
      return (
        period && currentMinutes >= period.start && currentMinutes <= period.end
      );
    } else if (timeSlot.type === "lunch") {
      return (
        currentMinutes >= schedule.lunch.start &&
        currentMinutes <= schedule.lunch.end
      );
    } else if (timeSlot.type === "closing") {
      return (
        currentMinutes >= schedule.closing.start &&
        currentMinutes <= schedule.closing.end
      );
    }

    return false;
  };

  const getTimeSlotStyles = (
    type,
    classCount = 1,
    isCurrentTime = false,
    isPastDate = false,
    isPastTime = false
  ) => {
    const styles = {
      morning: {
        background: isCurrentTime ? "#FFF5F6" : "#FFE3E6",
        border: isCurrentTime ? "2px solid #FF5C6C" : "none",
        height: 80,
      },
      closing: {
        background: isCurrentTime ? "#FFF5F6" : "#FFE3E6",
        border: isCurrentTime ? "2px solid #FF5C6C" : "none",
        height: 80,
      },
      lunch: {
        background: isCurrentTime ? "#FDF5FF" : "#FCF0FF",
        border: isCurrentTime ? "2px solid #DE5CFF" : "none",
        height: 160,
      },
      class: {
        1: {
          background: isCurrentTime ? "#F5F9FF" : "#D5E7FF",
          border: isCurrentTime ? "2px solid #5CA2FF" : "none",
          height: 160,
        },
        2: {
          background: isCurrentTime ? "#FFFBF5" : "#FFEED7",
          border: isCurrentTime ? "2px solid #FFBA5C" : "none",
          height: 320,
        },
        3: {
          background: isCurrentTime ? "#F7FDF9" : "#DDF7E5",
          border: isCurrentTime ? "2px solid #7BE09A" : "none",
          height: 480,
        },
      },
    };

    let result;
    if (type === "class") {
      if (classCount >= 3) result = styles.class[3];
      else if (classCount === 2) result = styles.class[2];
      else result = styles.class[1];
    } else {
      result = styles[type] || styles.class[1];
    }

    // 지나간 날짜이거나 당일의 지나간 시간인 경우 회색 처리
    if (isPastDate || isPastTime) {
      result = {
        ...result,
        background: "#F7F7FA",
        border: "none",
      };
    }

    return result;
  };

  const handleAddContent = () => {
    // 콘텐츠 등록 팝업 열기 (추후 구현)
    setIsPopupOpen(true);
    console.log("콘텐츠 등록 팝업 열기");
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleTimeSlotClick = (timeSlot) => {
    // 타임슬롯 편집 팝업 열기 (추후 구현)
    console.log("타임슬롯 편집:", timeSlot);
  };

  const handleNavigateWeek = (direction) => {
    const newOffset = direction === "prev" ? weekOffset - 1 : weekOffset + 1;
    onWeekOffsetChange(newOffset);
  };

  const weekDates = getWeekDates();
  const currentTimePosition = getCurrentTimePosition();
  
  // weekOffset을 고려한 현재 표시 중인 주의 대표 날짜 계산
  const getDisplayDate = () => {
    const today = new Date();
    const monday = new Date(today);
    const day = monday.getDay();
    const diff = monday.getDate() - day + (day === 0 ? -6 : 1);
    monday.setDate(diff);
    
    // weekOffset을 적용하여 실제 표시되고 있는 주로 이동
    monday.setDate(monday.getDate() + weekOffset * 7);
    
    return monday;
  };
  
  const displayDate = getDisplayDate();

  // 콘텐츠 데이터 관리 함수
  const getContentData = (dayIndex, periodKey) => {
    // USE_DUMMY_DATA는 현재 false이므로 더미 데이터 로직은 생략하거나 주석 처리할 수 있습니다.
    // 여기서는 설명을 위해 남겨둡니다.
    if (USE_DUMMY_DATA && periodKey.startsWith('class')) {
        const period = parseInt(periodKey.replace('class', ''), 10);
      const dummyContentMatrix = {
        0: { 1: { hasContent: true, classCount: 1 }, 2: { hasContent: false }, 3: { hasContent: true, classCount: 2, spans: [3, 4] }, 4: { hasContent: false, spannedBy: 3 }, 5: { hasContent: false }, 6: { hasContent: true, classCount: 1 }, 7: { hasContent: false } },
        1: { 1: { hasContent: true, classCount: 3, spans: [1, 2, 3] }, 2: { hasContent: false, spannedBy: 1 }, 3: { hasContent: false, spannedBy: 1 }, 4: { hasContent: false }, 5: { hasContent: true, classCount: 1 }, 6: { hasContent: false }, 7: { hasContent: true, classCount: 1 } },
        2: { 1: { hasContent: false }, 2: { hasContent: true, classCount: 1 }, 3: { hasContent: false }, 4: { hasContent: true, classCount: 1 }, 5: { hasContent: true, classCount: 2, spans: [5, 6] }, 6: { hasContent: false, spannedBy: 5 }, 7: { hasContent: false } },
        3: { 1: { hasContent: false }, 2: { hasContent: true, classCount: 3, spans: [2, 3, 4] }, 3: { hasContent: false, spannedBy: 2 }, 4: { hasContent: false, spannedBy: 2 }, 5: { hasContent: false }, 6: { hasContent: false }, 7: { hasContent: true, classCount: 1 } },
        4: { 1: { hasContent: true, classCount: 1 }, 2: { hasContent: false }, 3: { hasContent: true, classCount: 1 }, 4: { hasContent: false }, 5: { hasContent: false }, 6: { hasContent: true, classCount: 1 }, 7: { hasContent: false } },
      };
      return dummyContentMatrix[dayIndex]?.[period] || { hasContent: false };
    }

    // 실제 데이터 로직
    if (!eduTimetableDetail || !eduTimetableDetail.dailyContents) {
      return { hasContent: false };
    }

    const date = weekDates[dayIndex];
    const dayKey = `day-${date.getDate().toString().padStart(2, '0')}`;
    
    const dayContent = eduTimetableDetail.dailyContents[dayKey];
    if (dayContent && dayContent[periodKey]) {
      return {
        hasContent: true,
        title: dayContent[periodKey].contentTitle,
        // classCount는 월별 뷰에서 그룹화 로직으로 계산되므로 여기서는 일단 제외
      };
    }

    return { hasContent: false };
  };

  return (
    <TimelineContainer>
      <TimelineHeader>
        <HeaderLeft>
          <YearMonth>
            {displayDate.getFullYear()}년 {displayDate.getMonth() + 1}월
          </YearMonth>
          <NavigationControls>
            <TodayButton onClick={() => onWeekOffsetChange(0)}>
              <TodayText>Today</TodayText>
            </TodayButton>
            <ArrowButtons>
              <ArrowButton onClick={() => handleNavigateWeek("prev")}>
                {/* 왼쪽 화살표 */}
                <svg
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6.43359L9.43433 15L18 23.5657"
                    stroke="#AEAEB2"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ArrowButton>

              <ArrowButton onClick={() => handleNavigateWeek("next")}>
                {/* 오른쪽 화살표 */}
                <svg
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 6.43359L20.5657 15L12 23.5657"
                    stroke="#AEAEB2"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ArrowButton>
            </ArrowButtons>
          </NavigationControls>
        </HeaderLeft>
        <HeaderRight>
          <ViewTypeSelector>
            <ViewTypeButton
              active={selectedViewType === "weekly"}
              onClick={() => {
                setSelectedViewType("weekly");
                onViewTypeChange("weekly");
              }}
            >
              주
            </ViewTypeButton>
            <ViewTypeButton
              active={selectedViewType === "monthly"}
              onClick={() => {
                setSelectedViewType("monthly");
                onViewTypeChange("monthly");
              }}
            >
              월
            </ViewTypeButton>
          </ViewTypeSelector>
          <AddContentMainButton onClick={handleAddContent}>
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12.4683"
                cy="12.3835"
                r="7.60791"
                stroke="#256EF4"
                strokeWidth="2"
              />
              <line
                x1="12.2383"
                y1="8.42432"
                x2="12.2383"
                y2="12.4626"
                stroke="#256EF4"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="14.2997"
                y1="13.9197"
                x2="12.2734"
                y2="12.4763"
                stroke="#256EF4"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            콘텐츠 편성하기
          </AddContentMainButton>
        </HeaderRight>
      </TimelineHeader>

      <TimelineContent>
        <TimelineGrid>
          <TimeLabelsColumn>
            <EmptyHeaderCell />
            <TimeLabel style={{ height: "80px" }}>아침 조례</TimeLabel>
            <TimeLabel>1교시</TimeLabel>
            <TimeLabel>2교시</TimeLabel>
            <TimeLabel>3교시</TimeLabel>
            <TimeLabel>4교시</TimeLabel>
            <TimeLabel style={{ height: "160px" }}>점심 시간</TimeLabel>
            <TimeLabel>5교시</TimeLabel>
            <TimeLabel>6교시</TimeLabel>
            <TimeLabel>7교시</TimeLabel>
            <TimeLabel style={{ height: "80px" }}>종례 시간</TimeLabel>
            <TimeLabel style={{ height: "480px" }}>방과후</TimeLabel>
          </TimeLabelsColumn>

          {weekDates.map((date, dayIndex) => (
            <DayColumn key={dayIndex}>
              <DayHeader isToday={isCurrentDay(date)}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <span>
                    {date.getDate()}일 (
                    {["일", "월", "화", "수", "목", "금", "토"][date.getDay()]})
                  </span>
                  {isCurrentDay(date) && (
                    <svg
                      width="68"
                      height="26"
                      viewBox="0 0 68 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.277344"
                        y="0.660156"
                        width="67"
                        height="25"
                        rx="12.5"
                        fill="#256EF4"
                      />
                      <path
                        d="M18.1496 8.20516V9.31516H15.2996V18.6602H13.9346V9.31516H11.0696V8.20516H18.1496ZM23.4148 18.7952C22.6448 18.7952 21.9448 18.6202 21.3148 18.2702C20.6948 17.9202 20.2048 17.4252 19.8448 16.7852C19.4948 16.1352 19.3198 15.3852 19.3198 14.5352C19.3198 13.6952 19.4998 12.9552 19.8598 12.3152C20.2298 11.6652 20.7298 11.1702 21.3598 10.8302C21.9898 10.4802 22.6948 10.3052 23.4748 10.3052C24.2548 10.3052 24.9598 10.4802 25.5898 10.8302C26.2198 11.1702 26.7148 11.6602 27.0748 12.3002C27.4448 12.9402 27.6298 13.6852 27.6298 14.5352C27.6298 15.3852 27.4398 16.1352 27.0598 16.7852C26.6898 17.4252 26.1848 17.9202 25.5448 18.2702C24.9048 18.6202 24.1948 18.7952 23.4148 18.7952ZM23.4148 17.5952C23.9048 17.5952 24.3648 17.4802 24.7948 17.2502C25.2248 17.0202 25.5698 16.6752 25.8298 16.2152C26.0998 15.7552 26.2348 15.1952 26.2348 14.5352C26.2348 13.8752 26.1048 13.3152 25.8448 12.8552C25.5848 12.3952 25.2448 12.0552 24.8248 11.8352C24.4048 11.6052 23.9498 11.4902 23.4598 11.4902C22.9598 11.4902 22.4998 11.6052 22.0798 11.8352C21.6698 12.0552 21.3398 12.3952 21.0898 12.8552C20.8398 13.3152 20.7148 13.8752 20.7148 14.5352C20.7148 15.2052 20.8348 15.7702 21.0748 16.2302C21.3248 16.6902 21.6548 17.0352 22.0648 17.2652C22.4748 17.4852 22.9248 17.5952 23.4148 17.5952ZM28.9145 14.5202C28.9145 13.6802 29.0845 12.9452 29.4245 12.3152C29.7645 11.6752 30.2295 11.1802 30.8195 10.8302C31.4195 10.4802 32.0895 10.3052 32.8295 10.3052C33.4695 10.3052 34.0645 10.4552 34.6145 10.7552C35.1645 11.0452 35.5845 11.4302 35.8745 11.9102V7.56016H37.2545V18.6602H35.8745V17.1152C35.6045 17.6052 35.2045 18.0102 34.6745 18.3302C34.1445 18.6402 33.5245 18.7952 32.8145 18.7952C32.0845 18.7952 31.4195 18.6152 30.8195 18.2552C30.2295 17.8952 29.7645 17.3902 29.4245 16.7402C29.0845 16.0902 28.9145 15.3502 28.9145 14.5202ZM35.8745 14.5352C35.8745 13.9152 35.7495 13.3752 35.4995 12.9152C35.2495 12.4552 34.9095 12.1052 34.4795 11.8652C34.0595 11.6152 33.5945 11.4902 33.0845 11.4902C32.5745 11.4902 32.1095 11.6102 31.6895 11.8502C31.2695 12.0902 30.9345 12.4402 30.6845 12.9002C30.4345 13.3602 30.3095 13.9002 30.3095 14.5202C30.3095 15.1502 30.4345 15.7002 30.6845 16.1702C30.9345 16.6302 31.2695 16.9852 31.6895 17.2352C32.1095 17.4752 32.5745 17.5952 33.0845 17.5952C33.5945 17.5952 34.0595 17.4752 34.4795 17.2352C34.9095 16.9852 35.2495 16.6302 35.4995 16.1702C35.7495 15.7002 35.8745 15.1552 35.8745 14.5352ZM39.0513 14.5202C39.0513 13.6802 39.2213 12.9452 39.5613 12.3152C39.9013 11.6752 40.3663 11.1802 40.9563 10.8302C41.5563 10.4802 42.2213 10.3052 42.9513 10.3052C43.6713 10.3052 44.2963 10.4602 44.8263 10.7702C45.3563 11.0802 45.7513 11.4702 46.0113 11.9402V10.4402H47.3913V18.6602H46.0113V17.1302C45.7413 17.6102 45.3363 18.0102 44.7963 18.3302C44.2663 18.6402 43.6463 18.7952 42.9363 18.7952C42.2063 18.7952 41.5463 18.6152 40.9563 18.2552C40.3663 17.8952 39.9013 17.3902 39.5613 16.7402C39.2213 16.0902 39.0513 15.3502 39.0513 14.5202ZM46.0113 14.5352C46.0113 13.9152 45.8863 13.3752 45.6363 12.9152C45.3863 12.4552 45.0463 12.1052 44.6163 11.8652C44.1963 11.6152 43.7313 11.4902 43.2213 11.4902C42.7113 11.4902 42.2463 11.6102 41.8263 11.8502C41.4063 12.0902 41.0713 12.4402 40.8213 12.9002C40.5713 13.3602 40.4463 13.9002 40.4463 14.5202C40.4463 15.1502 40.5713 15.7002 40.8213 16.1702C41.0713 16.6302 41.4063 16.9852 41.8263 17.2352C42.2463 17.4752 42.7113 17.5952 43.2213 17.5952C43.7313 17.5952 44.1963 17.4752 44.6163 17.2352C45.0463 16.9852 45.3863 16.6302 45.6363 16.1702C45.8863 15.7002 46.0113 15.1552 46.0113 14.5352ZM56.778 10.4402L51.828 22.5302H50.418L52.038 18.5702L48.723 10.4402H50.238L52.818 17.1002L55.368 10.4402H56.778Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </div>
              </DayHeader>

              {/* ⭐ 아침 조례 */}
              {(() => {
                const isPastDate = isPastDay(date);
                const timeSlot = { type: "morning", date };
                const isPastTimeSlot = isPastTime(timeSlot, date);
                const isPast = isPastDate || isPastTimeSlot;
                const styles = getTimeSlotStyles(
                  "morning",
                  1,
                  isCurrentTimeSlot(timeSlot, date),
                  isPastDate,
                  isPastTimeSlot
                );
                const contentData = getContentData(dayIndex, "morning");

                return (
                  <TimeSlotContainer height={styles.height}>
                    {contentData.hasContent ? (
                      <TimeSlotContent
                        background={styles.background}
                        border={styles.border}
                        onClick={() => handleTimeSlotClick(timeSlot)}
                        isPast={isPast}
                      >
                        <TimeSlotTitle isPast={isPast}>{contentData.title}</TimeSlotTitle>
                        <TimeSlotTime isPast={isPast}>8:30 - 8:50</TimeSlotTime>
                      </TimeSlotContent>
                    ) : (
                      <AddContentButton
                        onClick={isPast ? undefined : handleAddContent}
                        isPast={isPast}
                      >
                        <div className="icon">+</div>
                        <div className="text">콘텐츠 시간 편성</div>
                      </AddContentButton>
                    )}
                  </TimeSlotContainer>
                );
              })()}

              {/* 📚 1-4교시 - 스마트 그룹화 (큰 콘텐츠 지원) */}
              {(() => {
                const timeSlots = {
                  1: { time: "8:50 - 9:45" },
                  2: { time: "9:45 - 10:40" },
                  3: { time: "10:40 - 11:35" },
                  4: { time: "11:35 - 12:20" },
                };

                const isPastDate = isPastDay(date);
                const periods = [1, 2, 3, 4];
                const contentData = periods.map((period) => {
                  const data = getContentData(dayIndex, `class${period}`);
                  return {
                    period,
                    hasContent: data.hasContent,
                    title: data.title,
                    classCount: data.classCount || 1,
                    spans: data.spans,
                    spannedBy: data.spannedBy,
                    ...timeSlots[period],
                  };
                });

                // 스마트 그룹화 (spanned 콘텐츠 고려)
                const groupedSlots = [];
                let currentGroup = [];
                let i = 0;

                while (i < contentData.length) {
                  const slot = contentData[i];

                  if (slot.hasContent && !slot.spannedBy) {
                    // 콘텐츠가 있는 경우
                    if (currentGroup.length > 0) {
                      groupedSlots.push({ type: "empty", slots: currentGroup });
                      currentGroup = [];
                    }
                    groupedSlots.push({ type: "content", slot });

                    // spans가 있으면 해당 교시들을 건너뜀
                    if (slot.spans && slot.spans.length > 1) {
                      i += slot.spans.length;
                    } else {
                      i++;
                    }
                  } else if (slot.spannedBy) {
                    // 다른 콘텐츠에 의해 점유된 슬롯은 건너뜀
                    i++;
                  } else {
                    // 빈 슬롯
                    currentGroup.push(slot);
                    i++;
                  }
                }

                if (currentGroup.length > 0) {
                  groupedSlots.push({ type: "empty", slots: currentGroup });
                }

                return groupedSlots.map((group, groupIndex) => {
                  if (group.type === "content") {
                    const slot = group.slot;
                    const timeSlot = {
                      type: "class",
                      period: slot.period,
                      date,
                    };
                    const isPastTimeSlot = isPastTime(timeSlot, date);
                    const isPast = isPastDate || isPastTimeSlot;
                    const styles = getTimeSlotStyles(
                      "class",
                      slot.classCount,
                      isCurrentTimeSlot(timeSlot, date),
                      isPastDate,
                      isPastTimeSlot
                    ); // 실제 classCount 사용

                    return (
                      <TimeSlotContainer
                        key={`content-${slot.period}`}
                        height={styles.height}
                      >
                        <TimeSlotContent
                          background={styles.background}
                          border={styles.border}
                          onClick={() => handleTimeSlotClick(timeSlot)}
                          isPast={isPast}
                        >
                          <TimeSlotTitle isPast={isPast}>
                            {slot.title || `${slot.period}교시 컨텐츠`}
                          </TimeSlotTitle>
                          <TimeSlotTime isPast={isPast}>
                            {slot.time}
                          </TimeSlotTime>
                        </TimeSlotContent>
                      </TimeSlotContainer>
                    );
                  } else {
                    // 연속된 빈 슬롯들을 하나의 큰 콘텐츠 등록 버튼으로 합치기
                    const totalHeight = group.slots.length * 160; // 각 교시당 160px
                    const firstSlot = group.slots[0];
                    const isPastTimeSlot = isPastTime(
                      { type: "class", period: firstSlot.period, date },
                      date
                    );
                    const isPast = isPastDate || isPastTimeSlot;

                    return (
                      <TimeSlotContainer
                        key={`empty-${groupIndex}`}
                        height={totalHeight}
                      >
                        <AddContentButton
                          onClick={isPast ? undefined : handleAddContent}
                          isPast={isPast}
                          style={{
                            opacity: isPast ? 0.5 : 1,
                          }}
                        >
                          <div className="icon">+</div>
                          <div className="text">콘텐츠 시간 편성</div>
                        </AddContentButton>
                        {isPopupOpen && (
                        <ContentPopup
                        onClose={handleClosePopup}
                        contentList={contentList}
                        />
                       )}
                      </TimeSlotContainer>
                    );
                  }
                });
              })()}

              {/* ⭐ 점심시간 */}
              {(() => {
                const isPastDate = isPastDay(date);
                const timeSlot = { type: "lunch", date };
                const isPastTimeSlot = isPastTime(timeSlot, date);
                const isPast = isPastDate || isPastTimeSlot;
                const styles = getTimeSlotStyles(
                  "lunch",
                  1,
                  isCurrentTimeSlot(timeSlot, date),
                  isPastDate,
                  isPastTimeSlot
                );
                const contentData = getContentData(dayIndex, "lunch");

                return (
                  <TimeSlotContainer height={styles.height}>
                    {contentData.hasContent ? (
                      <TimeSlotContent
                        background={styles.background}
                        border={styles.border}
                        onClick={() => handleTimeSlotClick(timeSlot)}
                        isPast={isPast}
                      >
                        <TimeSlotTitle isPast={isPast}>{contentData.title}</TimeSlotTitle>
                        <TimeSlotTime isPast={isPast}>12:20 - 13:20</TimeSlotTime>
                      </TimeSlotContent>
                    ) : (
                      <AddContentButton
                        onClick={isPast ? undefined : handleAddContent}
                        isPast={isPast}
                      >
                        <div className="icon">+</div>
                        <div className="text">콘텐츠 시간 편성</div>
                      </AddContentButton>
                    )}
                  </TimeSlotContainer>
                );
              })()}

              {/* 📚 5-7교시 - 스마트 그룹화 (큰 콘텐츠 지원) */}
              {(() => {
                const timeSlots = {
                  5: { time: "13:20 - 14:15" },
                  6: { time: "14:15 - 15:10" },
                  7: { time: "15:10 - 16:05" },
                };

                const isPastDate = isPastDay(date);
                const periods = [5, 6, 7];
                const contentData = periods.map((period) => {
                  const data = getContentData(dayIndex, `class${period}`);
                  return {
                    period,
                    hasContent: data.hasContent,
                    title: data.title,
                    classCount: data.classCount || 1,
                    spans: data.spans,
                    spannedBy: data.spannedBy,
                    ...timeSlots[period],
                  };
                });

                // 스마트 그룹화 (spanned 콘텐츠 고려)
                const groupedSlots = [];
                let currentGroup = [];
                let i = 0;

                while (i < contentData.length) {
                  const slot = contentData[i];

                  if (slot.hasContent && !slot.spannedBy) {
                    // 콘텐츠가 있는 경우
                    if (currentGroup.length > 0) {
                      groupedSlots.push({ type: "empty", slots: currentGroup });
                      currentGroup = [];
                    }
                    groupedSlots.push({ type: "content", slot });

                    // spans가 있으면 해당 교시들을 건너뜀
                    if (slot.spans && slot.spans.length > 1) {
                      i += slot.spans.length;
                    } else {
                      i++;
                    }
                  } else if (slot.spannedBy) {
                    // 다른 콘텐츠에 의해 점유된 슬롯은 건너뜀
                    i++;
                  } else {
                    // 빈 슬롯
                    currentGroup.push(slot);
                    i++;
                  }
                }

                if (currentGroup.length > 0) {
                  groupedSlots.push({ type: "empty", slots: currentGroup });
                }

                return groupedSlots.map((group, groupIndex) => {
                  if (group.type === "content") {
                    const slot = group.slot;
                    const timeSlot = {
                      type: "class",
                      period: slot.period,
                      date,
                    };
                    const isPastTimeSlot = isPastTime(timeSlot, date);
                    const isPast = isPastDate || isPastTimeSlot;
                    const styles = getTimeSlotStyles(
                      "class",
                      slot.classCount,
                      isCurrentTimeSlot(timeSlot, date),
                      isPastDate,
                      isPastTimeSlot
                    ); // 실제 classCount 사용

                    return (
                      <TimeSlotContainer
                        key={`content-${slot.period}`}
                        height={styles.height}
                      >
                        <TimeSlotContent
                          background={styles.background}
                          border={styles.border}
                          onClick={() => handleTimeSlotClick(timeSlot)}
                          isPast={isPast}
                        >
                          <TimeSlotTitle isPast={isPast}>
                            {slot.title || `${slot.period}교시 컨텐츠`}
                          </TimeSlotTitle>
                          <TimeSlotTime isPast={isPast}>
                            {slot.time}
                          </TimeSlotTime>
                        </TimeSlotContent>
                      </TimeSlotContainer>
                    );
                  } else {
                    // 연속된 빈 슬롯들을 하나의 큰 콘텐츠 등록 버튼으로 합치기
                    const totalHeight = group.slots.length * 160; // 각 교시당 160px
                    const firstSlot = group.slots[0];
                    const isPastTimeSlot = isPastTime(
                      { type: "class", period: firstSlot.period, date },
                      date
                    );
                    const isPast = isPastDate || isPastTimeSlot;

                    return (
                      <TimeSlotContainer
                        key={`empty-${groupIndex}`}
                        height={totalHeight}
                      >
                        <AddContentButton
                          onClick={isPast ? undefined : handleAddContent}
                          isPast={isPast}
                          style={{
                            opacity: isPast ? 0.5 : 1,
                          }}
                        >
                          <div className="icon">+</div>
                          <div className="text">콘텐츠 시간 편성</div>
                        </AddContentButton>
                      </TimeSlotContainer>
                    );
                  }
                });
              })()}

              {/* ⭐ 종례시간 */}
              {(() => {
                const isPastDate = isPastDay(date);
                const timeSlot = { type: "after-class", date };
                const isPastTimeSlot = isPastTime(timeSlot, date);
                const isPast = isPastDate || isPastTimeSlot;
                const styles = getTimeSlotStyles(
                  "closing",
                  1,
                  isCurrentTimeSlot(timeSlot, date),
                  isPastDate,
                  isPastTimeSlot
                );
                const contentData = getContentData(dayIndex, "after-class");

                return (
                  <TimeSlotContainer height={styles.height}>
                    {contentData.hasContent ? (
                      <TimeSlotContent
                        background={styles.background}
                        border={styles.border}
                        onClick={() => handleTimeSlotClick(timeSlot)}
                        isPast={isPast}
                      >
                        <TimeSlotTitle isPast={isPast}>{contentData.title}</TimeSlotTitle>
                        <TimeSlotTime isPast={isPast}>16:05 - 16:15</TimeSlotTime>
                      </TimeSlotContent>
                    ) : (
                      <AddContentButton
                        onClick={isPast ? undefined : handleAddContent}
                        isPast={isPast}
                      >
                        <div className="icon">+</div>
                        <div className="text">콘텐츠 시간 편성</div>
                      </AddContentButton>
                    )}
                  </TimeSlotContainer>
                );
              })()}

              {/* 📚 방과후 - 현재는 항상 콘텐츠 등록 버튼만 표시 */}
              {(() => {
                const isPastDate = isPastDay(date);
                const timeSlot = { type: "afterschool", date };
                const isPastTimeSlot = isPastTime(timeSlot, date);
                const isPast = isPastDate || isPastTimeSlot;

                return (
                  <TimeSlotContainer height={480}>
                    <AddContentButton
                      onClick={isPast ? undefined : handleAddContent}
                      isPast={isPast}
                      style={{
                        opacity: isPast ? 0.5 : 1,
                      }}
                    >
                      <div className="icon">+</div>
                      <div className="text">콘텐츠 시간 편성</div>
                    </AddContentButton>
                  </TimeSlotContainer>
                );
              })()}
            </DayColumn>
          ))}

          {/* 현재 시간 표시기 */}
          <CurrentTimeIndicator position={currentTimePosition}>
            <CurrentTimeLine />
          </CurrentTimeIndicator>

          {/* 현재 시간 라벨 (좌측) */}
          <TimeIndicatorLabel position={currentTimePosition}>
            {currentTime.getHours()}:
            {currentTime.getMinutes().toString().padStart(2, "0")}
          </TimeIndicatorLabel>

          {/* 당일 특별 라인 (현재 시간 라인이 있는 경우만) */}
          {weekDates.findIndex(isCurrentDay) >= 0 && (
            <TodayTimeLineIndicator
              dayIndex={weekDates.findIndex(isCurrentDay)}
              position={currentTimePosition}
            >
              <svg
                width="233"
                height="12"
                viewBox="0 0 233 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M227.001 0.667969C229.946 0.66797 232.334 3.05546 232.334 6.00098C232.334 8.94649 229.946 11.334 227.001 11.334C224.397 11.334 222.231 9.46837 221.763 7.00098H11.2393C10.7711 9.46837 8.60461 11.334 6.00098 11.334C3.05546 11.334 0.667969 8.9465 0.667969 6.00098C0.667969 3.05546 3.05546 0.667969 6.00098 0.667969C8.60461 0.667969 10.7711 2.53358 11.2393 5.00098H221.763C222.231 2.53358 224.397 0.667969 227.001 0.667969Z"
                  fill="#0A4BC2"
                />
              </svg>
            </TodayTimeLineIndicator>
          )}
        </TimelineGrid>
      </TimelineContent>
      {isPopupOpen && (
        <ContentPopup
          onClose={handleClosePopup}
          contentList={contentList}
        />
      )}
    </TimelineContainer>
  );
};

// Styled Components
const TimelineContainer = styled.div`
  width: 1240px;
  height: 2047px;
  background: white;
  display: flex;
  flex-direction: column;
`;

const TimelineHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px 20px 0px;
  border-bottom: 1px solid #d1d1d6;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const YearMonth = styled.span`
  color: #323232;
  font-size: 36px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 36px;
`;

const NavigationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
`;

const TodayButton = styled.div`
  height: 48px;
  padding: 13px 18px;
  background: white;
  border-radius: 8px;
  border: 1px solid #d1d1d6;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const TodayText = styled.span`
  color: #323232;
  font-size: 17px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
`;

const ArrowButtons = styled.div`
  display: flex;
  gap: 10px;
`;

const ArrowButton = styled.button`
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f0f0f0;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const ViewTypeSelector = styled.div`
  height: 48px;
  padding: 4px;
  background: #eef2f7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0;
`;

const ViewTypeButton = styled.button`
  height: 40px;
  min-width: 69px;
  padding: 4px 27px;
  background: ${(props) => (props.active ? "white" : "transparent")};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #323232;
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 400;
`;

const AddContentMainButton = styled.button`
  height: 48px;
  width: 100%;
  padding: 8px 12px;
  background: #f0f4ff;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 16px;
  color: #256ef4;
  font-family: Pretendard;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const TimelineContent = styled.div`
  flex: 1;
  overflow: hidden;
`;

const TimelineGrid = styled.div`
  display: flex;
  min-height: 1970px;
  position: relative;
`;

const TimeLabelsColumn = styled.div`
  width: 75px;
  height: 1970px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #d1d1d6;
  border-bottom: 1px solid #d1d1d6;
`;

const EmptyHeaderCell = styled.div`
  height: 50px;
  width: 75px;
  background: #f2f2f7;
  border-bottom: 1px solid #d1d1d6;
  border-right: 1px solid #d1d1d6;
`;

const TimeLabel = styled.div`
  height: 160px;
  width: 75px;
  padding: 15px 0px;
  color: #aeaeb2;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DayColumn = styled.div`
  width: 233px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #d1d1d6;
`;

const DayHeader = styled.div`
  height: 50px;
  padding: 15px 5px;
  background: #f2f2f7;
  border-bottom: 1px solid #d1d1d6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: ${(props) => (props.isToday ? "#256EF4" : "#666666")};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 700 : 400)};
  line-height: 24px;
`;

const CurrentTimeIndicator = styled.div`
  position: absolute;
  left: 75px;
  top: ${(props) => props.position}px;
  width: calc(100% - 75px);
  z-index: 10;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

const TimeIndicatorLabel = styled.div`
  position: absolute;
  left: 0px;
  top: ${(props) => props.position - 12}px;
  width: 74px;
  height: 24px;
  background: #8e8e93;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CurrentTimeLine = styled.div`
  width: 100%;
  height: 1px;
  background: transparent;
  border-top: 2px dashed #b6b6b9;
  z-index: 900;
`;

const TodayTimeLineIndicator = styled.div`
  position: absolute;
  top: ${(props) => props.position - 8}px; /* SVG 높이의 절반만큼 위로 이동 */
  left: ${(props) => 75 + props.dayIndex * 233}px;
  width: 233px;
  height: 12px;
  pointer-events: none;
  z-index: 999;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export default MoleculeContentTimeline;
